import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';

import { Account } from '@contracts/interfaces/account.interface'
import { AccountService } from '../../../services/account.service';

@Component({
  selector: 'app-bank-account-settings',
  templateUrl: './bank-account-settings.component.html',
  styleUrls: ['./bank-account-settings.component.scss']
})
export class BankAccountSettingsComponent implements OnInit {
  readonly categoryOptions = [
    { value: 'business-account', label: 'Business account' },
    { value: 'tax-account', label: 'Tax account' },
    { value: 'customer-account', label: 'Customer account' }
  ];

  public accounts: Account[] = [];
  public newAccountName = '';
  public newAccountNumber = '';
  public newAccountCategory = 'business-account';
  public isSaving = false;
  public isAdding = false;

  constructor(private accountService: AccountService) { }

  ngOnInit(): void {
    this.reload();    
  }

  reload() {
    this.accountService.find({}).subscribe((accounts: Account[]) => {
      this.accounts = (accounts || []).sort((a, b) => {
        const orderDiff = (a?.order || 0) - (b?.order || 0);
        if (orderDiff !== 0) {
          return orderDiff;
        }
        return (a?.name || '').localeCompare(b?.name || '');
      });
    })
  }

  save() {
    if (!this.accounts.length || this.isSaving) {
      return;
    }

    this.isSaving = true;

    forkJoin(this.accounts.map(account => this.accountService.update(account))).subscribe(() => {
      this.isSaving = false;
      this.reload();
    }, () => {
      this.isSaving = false;
    });
  }

  add () {
    if (!this.canAddAccount() || this.isAdding) {
      return;
    }

    let account: Account = {
      name: this.newAccountName.trim(),
      accountNumber: this.newAccountNumber.trim(),
      balance: 0,
      category: this.newAccountCategory,
      lastUpdated: new Date(),
      order: this.accounts.length,
      ignoreCredits: false,
      ignoreDebits: false,
      automaticallyAddVAT: false,
      customer: null,
      draftInvoice: {
        mcrItems: [],
        serviceItems: []
      },
      monthlyNotes: '',
      invoices: []
    }

    this.isAdding = true;

    this.accountService.create(account).subscribe(() => {
      this.isAdding = false;
      this.newAccountName = '';
      this.newAccountNumber = '';
      this.newAccountCategory = 'business-account';
      this.reload();
    }, () => {
      this.isAdding = false;
    });
  }
  
  delete (account: Account) {
    this.accountService.delete(account).subscribe(() => {
      this.reload();
    })
  }

  canAddAccount() {
    return !!this.newAccountName.trim() && !!this.newAccountNumber.trim();
  }

}
